import { Editor } from 'grapesjs';
import { faGifts } from '@fortawesome/pro-solid-svg-icons/faGifts';
import { EditorComponentDefinition } from '../types';
import { RewardsListGrapesComponent } from './rewards-list-grapes-component';
import { Toolbar } from '../../utils';
import { markChildrenWithParentType } from '../../../services/copy-paste/copy-paste-utils';

export const rewardsComponentDefinition: EditorComponentDefinition = {
  id: 'rewards',
  icon: faGifts,
  category: 'Loyalty',
  getLabel: ({ t }) => t('editor.component.rewards'),
  component: RewardsGrapesComponent,
  copyPasteHelper: markChildrenWithParentType,
};

export function RewardsGrapesComponent(editor: Editor) {
  RewardsListGrapesComponent(editor);

  const languages = editor.Config?.context?.languages || [];

  editor.DomComponents.addType(rewardsComponentDefinition.id, {
    isComponent: (el: HTMLElement) => {
      return el.tagName === 'DIV' && el.classList.contains('qlfeditor-rewards');
    },
    model: {
      defaults: {
        tagName: 'div',
        category: 'content',
        droppable: false,
        draggable: '[data-gjs-type=column]',
        components: [
          {
            type: 'custom-text',
            attributes: {
              style: 'margin-bottom: 1em;',
            },
            draggable: false,
            droppable: false,
            copyable: false,
            i18nAttributes: {
              ...Object.fromEntries(
                languages.map((language: string) => [
                  language,
                  {
                    content: `
                  <div class="ql-snow">
                    <div class="ql-editor">
                      <h1 class="qlfeditor-title ql-align-center">${editor.I18n.t(
                        'editor.rewards.title',
                        { l: language },
                      )}</h1>
                    </div>
                  </div>
                `,
                  },
                ]),
              ),
            },
          },
          {
            type: 'rewards-list',
          },
        ],
        attributes: {
          class: 'qlfeditor-rewards qlf-scrollable',
          tagName: 'section',
          'aria-label': 'aria.rewards.label',
          'aria-description': 'aria.rewards.description',
        },
        traits: [],
      },
      initToolbar: Toolbar,
    },
  });
}
